module.exports = __webpack_public_path__ + "img/1080_02.0af589a6.jpg";